import React, {ReactNode} from 'react';
import {sx} from './sx'
import Stack from '@mui/material/Stack'
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';
import CancelIcon from '@mui/icons-material/Cancel';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import Box from '@mui/material/Box';
import {SxType} from "@baseTypes/sx/sxTypes";
import {ITaskSingleVoyage} from "@containers/singleVoyage/tasks/types";
import CompleteCountTasksSingleVoyage
    from "@containers/singleVoyage/tasks/views/pointTasksInfo/CompleteCountTasksSingleVoyage";

interface IProps {
    sx?: {
        card?: SxType
    },
    children: ReactNode,
    childrenHeader?: ReactNode,
    size?: 'small',
    hasNothingTasksMessage?: boolean,
    showCompleteCountInHeader?: boolean
    tasks?: ITaskSingleVoyage[]
}

const PointTasksInfoContainerViewSingleVoyage = ({
                                                     hasNothingTasksMessage,
                                                     sx: sxProps = {},
                                                     childrenHeader,
                                                     children,
                                                     tasks,
                                                     showCompleteCountInHeader,
                                                 }: IProps) => {

    const {t} = useTranslation()

    return (
        <Box
            sx={sx.inner}
        >
            <Box
                sx={sx.innerHeader}
            >
                <Box
                    sx={sx.header}
                >
                    <Box
                        sx={sx.headerIcon}
                    >
                        <ContentPasteIcon sx={sx.headerIconContent}/>
                    </Box>

                    <Typography
                        sx={sx.headerTitle}
                    >
                        {showCompleteCountInHeader ?
                            <CompleteCountTasksSingleVoyage tasks={tasks || []}/>
                            : t('singleVoyage.tasks')}
                    </Typography>
                </Box>

                {childrenHeader && childrenHeader}
            </Box>

            <Box
                sx={{
                    ...sx.root,
                    ...(sxProps?.card ?? {})
                }}
            >

                {hasNothingTasksMessage && <Stack
                    sx={sx.nothing}
                    alignItems={'center'}
                    gap={1}
                >
                    <Typography
                        sx={sx.nothingText}
                    >
                        {t('singleVoyage.nothingTasksInPoint')}
                    </Typography>

                    <CancelIcon
                        sx={sx.clearIcon}
                    />
                </Stack>}

                {children}
            </Box>
        </Box>
    );
};

export default PointTasksInfoContainerViewSingleVoyage;
